import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { filterSystemID } from '@/utils/filters.js';
export default {
  props: {
    date: Object
  },
  filters: {
    filterSystemID: filterSystemID
  },
  data: function data() {
    return {
      ruleForm: {
        dictName: '',
        dictCode: '',
        systemId: this.date.systemId,
        dictStatus: ''
      },
      formJson: [{
        prop: 'systemId',
        label: '系统名称',
        disabled: true
      }, {
        prop: 'dictCode',
        label: '键值对键',
        placeholder: '请输入键值对键',
        maxlength: 64,
        maxclass: 'limit32'
      }, {
        prop: 'dictName',
        label: '键值对名称',
        placeholder: '请输入键值对名称',
        maxlength: 200,
        maxclass: 'limit256'
      }],
      rules: {
        dictCode: [{
          required: true,
          message: '请输入键值对键',
          trigger: 'blur'
        }],
        dictName: [{
          required: true,
          message: '请输入键值对值',
          trigger: 'blur'
        }],
        systemId: [{
          required: true,
          message: '请输入系统id',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    submitForm: function submitForm() {
      var _this = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this.$API.postRequest({
            url: _this.date.subType === 'edit' ? '/platform/dict/updateDictDetail' : '/platform/dict/addDict',
            data: _this.date.subType === 'addchild' ? _objectSpread(_objectSpread({}, _this.ruleForm), {}, {
              dictGroupCode: _this.date.dictGroupCode,
              id: _this.date.id,
              groupId: _this.date.groupId,
              parentId: _this.date.parentId
            }) : _objectSpread(_objectSpread({}, _this.ruleForm), {}, {
              dictGroupCode: _this.date.dictGroupCode,
              id: _this.date.id,
              groupId: _this.date.groupId,
              parentId: _this.date.parentId
            })
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this.$message({
                type: 'success',
                message: _this.date.subType === 'edit' ? '修改键值对成功' : '新增键值对成功'
              });
              sessionStorage.setItem('dist_info', null);
              // this.resetForm("ruleForm");
              _this.$emit('close', {
                subType: _this.date.subType,
                showAddDate: 'showAddDate'
              });
              _this.$emit('refresh');
            }
          });
        } else {
          _this.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
    },
    initForm: function initForm() {
      if (this.date) {
        // eslint-disable-next-line guard-for-in
        for (var key in this.ruleForm) {
          this.ruleForm[key] = this.date[key];
        }
      }
    },
    confirmsure: function confirmsure(bool) {
      if (bool) {
        this.submitForm();
      }
    },
    cancelDailog: function cancelDailog() {
      this.$emit('close', {
        subType: '',
        showAddDate: 'showAddDate'
      });
      // this.$emit('DictgroupAddSubmit', { bool: false})
    }
  },
  created: function created() {
    this.initForm();
  }
};